import React, { createContext, useContext, useEffect, useState } from "react";

// Create a context for colors
const ColorContext = createContext();

// Default colors
const defaultTheme = {
  primary: "#322D72",
  secondary: "#E98841", 
  default: "#667085",
  lightdark: "#333843",
  lightgrey: "#DEDEFA",
  iconintable: "#667085"
};

// ColorProvider component
export const ColorProvider = ({ children }) => {
  // Get colors from localStorage with fallback to defaults
  const [colors, setColors] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    const localColors = savedTheme ? JSON.parse(savedTheme) : {};
    
    return {
      primary: localColors?.primary || defaultTheme.primary,
      secondary: localColors?.secondary || defaultTheme.secondary,
      default: localColors?.default || defaultTheme.default,
      lightdark: localColors?.lightdark || defaultTheme.lightdark,
      lightgrey: localColors?.lightgrey || defaultTheme.lightgrey,
      iconintable: localColors?.iconintable || defaultTheme.iconintable
    };
  });

  // Update CSS variables when colors change
  useEffect(() => {
    document.documentElement.style.setProperty("--primary", colors.primary);
    document.documentElement.style.setProperty("--secondary", colors.secondary);
    document.documentElement.style.setProperty("--default", colors.default);
    document.documentElement.style.setProperty("--lightdark", colors.lightdark);
    document.documentElement.style.setProperty("--lightgrey", colors.lightgrey);
    document.documentElement.style.setProperty("--iconintable", colors.iconintable);
  }, [colors]);

  // Provide the colors to the context
  return (
    <ColorContext.Provider value={colors}>
      {children}
    </ColorContext.Provider>
  );
};

// Custom hook to use colors
export const useColors = () => useContext(ColorContext);